export default __webpack_public_path__ + "static/media/sidebar_places_gray.aa719580.svg";